module.exports = __webpack_public_path__ + "static/assets/55c342d45d3cbf9d279f5acacbff02a6.gif";